import Dashboard from "../pages/Dashboard/Dashboard";
import {
  LayoutGrid,
  Users,
  User,
  Settings,
  FilePenLine,
  PackageSearch,
  FileArchiveIcon,
} from "lucide-react";
import UserTable from "../pages/users";
import ConsultationTable from "../pages/consultation";
// import AccountantTable from "../pages/accountant";
import SettingsIndex from "../pages/settings/Settings";
import UploadedDocuments from "../pages/documents";
import SubAdminsList from "../pages/subAdmin/";
import FIllingManagementTable from "../pages/filling-management";
import BucketTable from "../pages/bucket";
import TransactionTable from "../pages/transaction";
import PageBanner from "../pages/PageBanner/PageBanner";
import Home from "../pages/home/Home";
import HomeBeforeLogin from "../pages/Home-before-login/HomeBeforeLogin";
import About from "../pages/about/About";

export interface AppRoute {
  key: string;
  label: string;
  url: string;
  icon?: React.ComponentType<any>;
  component?: React.ComponentType;
  children?: AppRoute[];
  hidden?: boolean;
  ignore?: number;
  type?: string;
}

const routes: AppRoute[] = [
  {
    key: "1",
    label: "Dashboard",
    url: "/",
    icon: LayoutGrid,
    component: Dashboard,
    type: "DASHBOARD",
  },

  {
    key: "2",
    label: "Sub Admins",
    url: "/sub-admins",
    icon: Users,
    component: SubAdminsList,
    type: "SUPER_ADMIN",
  },
  {
    key: "3",
    label: "Users",
    url: "/users",
    icon: User,
    component: UserTable,
    type: "USERS",
  },
  {
    key: "4",
    label: "Filling Management",
    url: "/filling-management",
    icon: FilePenLine,
    component: FIllingManagementTable,
    type: "FILLING_MANAGEMENT",
  },

  {
    key: "4",
    label: "Bucket",
    url: "/bucket",
    icon: FilePenLine,
    component: BucketTable,
    type: "BUCKET",
  },
  {
    key: "4",
    label: "Consultations",
    url: "/consultation",
    icon: Users,
    component: ConsultationTable,
    type: "CONSULTATION_BOOKING",
  },

  {
    key: "4",
    label: "Transaction",
    url: "/transaction",
    icon: Users,
    component: TransactionTable,
    type: "TRANSACTION",
  },

  {
    key: "6",
    label: "Documents",
    url: "/documents",
    icon: Users,
    component: UploadedDocuments,
    type: "DOCUMENTS",
  },

  {
    key: "7",
    label: "Settings",
    url: "/settings",
    icon: Settings,
    component: SettingsIndex,
    type: "SETTING",
  },

  {
    key: "8",
    label: "Pages",
    url: "page",
    icon: FileArchiveIcon,
    children: [
      {
        key: "8.1",
        label: "Home Page",
        url: "/homepage",
        component: Home,
        icon: Settings,
      },
      {
        key: "8.2",
        label: "Welcome Page",
        url: "/welcomepage",
        component: HomeBeforeLogin,
        icon: Settings,
      },
      {
        key: "8.3",
        label: "About Page",
        url: "/about",
        component: About,
        icon: Settings,
      },
    ],
  },
  {
    key: "9",
    label: "Page Banner",
    url: "/pagebanner",
    icon: FileArchiveIcon,
    component: PageBanner,
    type: "PAGES_BANNER",
  },
];

export default routes;
